import MediaQuery from 'react-responsive'
import mapValues from 'lodash/fp/mapValues'
import { sizes } from 'shared/lib/media'

// Prevents component from being rendered to the DOM given a
// `size` from `media.ts up to a optional maxSize.  For simple
// hiding using "display: none" use the helpers found in
// `shared/lib/responsiveness.

// react-responsive has a bug that causes a component to sibling
// components display name and styles.  To prevent this, wrap the
// component in another element.  `<div><DesktopLayout /></div>`

// Note for the future: we may want to create a new HoC in the
// future to support React Suspense using the [hidden] attribute
// on the React element.

// Render for Desktop
// const DesktopHeader = renderStart.large(Header)

// Render for Mobile
// const MobileHeader = renderUntil.large(Header)

export const renderStart = mapValues(
  (size: number) => (WrappedComponent, maxSize?: number) => props => (
    <>
      <MediaQuery minWidth={size} maxWidth={maxSize}>
        <WrappedComponent {...props} />
      </MediaQuery>
    </>
  ),
  sizes,
)

export const renderUntil = mapValues(
  (maxSize: number) => WrappedComponent => props => (
    <>
      <MediaQuery minWidth={sizes.base} maxWidth={maxSize}>
        <WrappedComponent {...props} />
      </MediaQuery>
    </>
  ),
  sizes,
)
